import styled from "styled-components";

export const GameImageBox = styled.div`
  width: 100%;
  max-width: 11rem;
 background-image: url("${props => props.theme.assets.images.games_icons_background.BGGameBlack_png.toString()}");
 background-repeat: no-repeat;
 background-size: 100%;
`;